import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaArrowLeft } from "react-icons/fa";
import UserDashboardLayout from "../../../Components/UserDashboardLayout/UserDashboardLayout";
import AccountSetupCard from "../../../Components/AccountSetup/AccountSetupCard";
import MapProduct from "../../../utils/ProductMapper/MapProduct";
import ProductLicensesTable from "./ProductLicensesTable";
import RequestQuote from "../../../Components/User/RequestQuote/requestquote";
import Loading from "react-fullscreen-loading";
import "./UserDashboard.css";

export default function UserDashboard() {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const getStats = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/user/dashboard/stats`,
        { headers: { "access-token": localStorage.getItem("accessToken") } }
      );
      if (response.data.status) {
        setStats(response.data.stats);
      }
    } catch (err) {
      console.error("Error fetching dashboard stats:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStats();
  }, []);

  const totals = stats?.totals;
  const products = stats?.products || [];

  return (
    <div>
      <UserDashboardLayout />
      <Loading loading={loading} background="#fff" loaderColor="#883484" />
      <div className="content-page-bg">
        <div className="content-page">
          <div className="content">
            {/* Renders nothing once the email is confirmed and the profile is
                filled in. In normal flow, so it can never cover the content
                below it the way the old floating banner did. */}
            {!loading && <AccountSetupCard />}
            {!loading && (!totals || totals.total === 0) ? (
              <RequestQuote />
            ) : (
              totals && (
                <>
                  <div className="profile-card">
                    <div>
                      <h2>Welcome back 👋</h2>
                      <p>Here’s an overview of your SPCAD licenses at a glance.</p>
                    </div>
                  </div>

                  <div className="stats-grid">
                    <div className="stat-card"><h3>{totals.total}</h3><p>Total Licenses</p></div>
                    <div className="stat-card"><h3>{totals.active}</h3><p>Active</p></div>
                    <div className="stat-card"><h3>{totals.expiring_soon}</h3><p>Expiring Soon</p></div>
                    <div className="stat-card"><h3>{totals.expired}</h3><p>Expired</p></div>
                    <div className="stat-card"><h3>{totals.in_use}</h3><p>In Use</p></div>
                  </div>

                  {selectedProduct ? (
                    <>
                      <div className="product-licenses-header">
                        <button className="back-button" onClick={() => setSelectedProduct(null)}>
                          <FaArrowLeft /> Back to products
                        </button>
                        <h3 style={{ margin: "0px" }}>{MapProduct(selectedProduct, "default")}</h3>
                      </div>
                      <ProductLicensesTable product={selectedProduct} />
                    </>
                  ) : (
                    <>
                      <h2>Your Products</h2>
                      <p>Select a product to view and manage its licenses.</p>
                      <div className="product-grid">
                        {products.map((p) => (
                          <button
                            key={p.product}
                            className="product-card"
                            onClick={() => setSelectedProduct(p.product)}
                          >
                            <div className="product-card-header">
                              {MapProduct(p.product, "default")}
                            </div>
                            <div className="product-count">
                              <span className="product-count-number">{p.total}</span>
                              <span className="product-count-label">
                                license{p.total === 1 ? "" : "s"}
                              </span>
                            </div>
                            <div className="product-breakdown">
                              <span className="pb active">{p.active} Active</span>
                              <span className="pb expiring">{p.expiring_soon} Expiring</span>
                              <span className="pb expired">{p.expired} Expired</span>
                            </div>
                          </button>
                        ))}
                      </div>
                    </>
                  )}
                </>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
